import CryptoJS from "crypto-js";

export const hashParams = (params) => {
  const paramsString = JSON.stringify(params);
  return CryptoJS.MD5(paramsString).toString();
};



export const createQueryParams = (params) => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          queryParams.append(key, value.join(','));
        } else if (value !== null && value !== undefined){
        queryParams.append(key, value);
        }
    });
    return queryParams.toString();

}